import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Spin,
  Typography,
  VertButton,
  VertInput,
  VertModal,
  message,
  notification,
} from '@vertem-core/vertice-ds';
import { Col, Row } from 'antd';
import * as yup from 'yup';
import 'Assets/styles/default/components/Modals/Modals.less';
import redemptionsApiClient from 'Services/Apis/Spot/redemptionsClient';
import { useSelector } from 'react-redux';

const ModalSendDocument = ({ isVisible, document, setIsVisible, spot, callbackSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [send, setSend] = useState(false);
  const [success, setSuccess] = useState(true);
  const [form] = Form.useForm();
  const schema = yup.object().shape({
    email: yup.string().required('Email é obrigatório').email('Email inválido'),
  });

  const yupSync = {
    async validator({ field }, value) {
      await schema.validateSyncAt(field, { [field]: value });
    },
  };

  const userProfile = useSelector((state) => state.oidc.user.profile);
  const userInfos = useSelector(({ oidc: data }) => data);
  const {
    user: { profile, access_token },
  } = userInfos;

  const userName = profile.username || profile['custom:login'];

  const config = {
    headers: {
      campaignId: userProfile['custom:campaign_id'],
      catalogId: userProfile['custom:catalog_id'],
      participantId: userProfile['custom:participant_id'],
      Authorization: `Bearer ${access_token}`,
      username: userName,
      contentType: 'application/json',
    },
  };

  const sendEmail = async (email) => {
    setLoading(true);
    const data = {
      redemptionId: spot.id,
      email: email,
      fileType: document.type,
      fileLink: document.url,
    };

    await redemptionsApiClient
      .post('/RedemptionFile/SendFileEmail', data, config)
      .then((res) => {
        message.success('Email enviado com sucesso!');
        setSuccess(true);
        setLoading(false);
      })
      .catch((err) => {
        setSend(false);
        setSuccess(false);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (success && callbackSuccess) {
      callbackSuccess()
    }
  }, [ success, callbackSuccess ]);

  return (
    <VertModal
      onCancel={() => setIsVisible(false)}
      open={isVisible}
      centered
      footer={
        <>
          {send ? (
            <>
              {success ? (
                <Row justify="center">
                  <Col xs={10} sm={10} md={10} lg={10} xl={10} xxl={10}>
                    <VertButton
                      className="button-view-redemption"
                      onClick={() => setIsVisible(false)}
                      loading={loading}
                    >
                      FECHAR
                    </VertButton>
                  </Col>
                </Row>
              ) : (
                <Row justify="space-between">
                  <Col xs={10} sm={10} md={10} lg={10} xl={10} xxl={10}>
                    <VertButton
                      className="button-view-redemption"
                      onClick={() => setIsVisible(false)}
                      loading={loading}
                    >
                      CANCELAR
                    </VertButton>
                  </Col>

                  <Col xs={10} sm={10} md={10} lg={10} xl={10} xxl={10}>
                    <VertButton
                      type="highlight"
                      className="button-view-redemption"
                      onClick={() => setSend(false)}
                    >
                      TENTAR NOVAMENTE
                    </VertButton>
                  </Col>
                </Row>
              )}
            </>
          ) : (
            <Row justify="space-between">
              <Col xs={10} sm={10} md={10} lg={10} xl={10} xxl={10}>
                <VertButton
                  className="button-view-redemption"
                  onClick={() => setIsVisible(false)}
                >
                  CANCELAR
                </VertButton>
              </Col>

              <Col xs={10} sm={10} md={10} lg={10} xl={10} xxl={10}>
                <VertButton
                  type="highlight"
                  className="button-view-redemption"
                  htmlType="submit"
                  form="form-send-document"
                  loading={loading}
                >
                  ENVIAR DOCUMENTO
                </VertButton>
              </Col>
            </Row>
          )}
        </>
      }
    >
      {loading ? (
        <Spin />
      ) : send ? (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          {success ? (
            <Typography.Text className="modal-title">Sucesso!</Typography.Text>
          ) : (
            <Typography.Text className="modal-title">
              Falha no envio!
            </Typography.Text>
          )}
          <div style={{ textAlign: 'center' }}>
            {success ? (
              <Typography.Text>
                O documento foi enviado com sucesso para seu e-mail.
              </Typography.Text>
            ) : (
              <Typography.Text>
                Houve uma falha no envio do documento, tente novamente, caso a
                falha persista, entre em contato com a central.
              </Typography.Text>
            )}
          </div>
        </div>
      ) : (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <div
            style={{
              textAlign: 'center',
            }}
          >
            <Typography.Text>
              Confirme abaixo seu e-mail para receber{' '}
              {document.type === 1 ? 'a COTAÇÃO' : 'o TERMO'}.
            </Typography.Text>
          </div>

          <Form
            style={{
              marginBottom: '20px',
              marginTop: '20px',
              width: '100%',
            }}
            form={form}
            scrollToFirstError
            onFinish={(values) => {
              sendEmail(values.email);
            }}
            name="basic"
            initialValues={{ remember: true }}
            id="form-send-document"
            autoComplete="off"
          >
            <Form.Item name="email" rules={[yupSync]} validateTrigger="onBlur">
              <VertInput placeholder="* Email" />
            </Form.Item>
          </Form>
        </div>
      )}
    </VertModal>
  );
};

ModalSendDocument.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  document: PropTypes.object.isRequired,
  callbackSuccess: PropTypes.func
};

export default ModalSendDocument;
